import { render, staticRenderFns } from "./data-table-create-calculation-production.vue?vue&type=template&id=aa6f2554&scoped=true&"
import script from "./data-table-create-calculation-production.vue?vue&type=script&lang=js&"
export * from "./data-table-create-calculation-production.vue?vue&type=script&lang=js&"
import style0 from "./data-table-create-calculation-production.vue?vue&type=style&index=0&id=aa6f2554&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6f2554",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa6f2554')) {
      api.createRecord('aa6f2554', component.options)
    } else {
      api.reload('aa6f2554', component.options)
    }
    module.hot.accept("./data-table-create-calculation-production.vue?vue&type=template&id=aa6f2554&scoped=true&", function () {
      api.rerender('aa6f2554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations/create/additions/data-table-create-calculation-production.vue"
export default component.exports